import type { LucideIcon } from "lucide-react";
import { Eye, Handshake, Lightbulb, Sparkles, Star, Users } from "lucide-react";
import type { CircleActionVariant } from "./circle-action-variants";
import type { FieldVariant } from "./field-variants";

type CorporateValuePreset = {
  variant: CircleActionVariant;
  Icon: LucideIcon;
  keywords: string[];
};

const PRESETS: CorporateValuePreset[] = [
  { variant: "emerald", Icon: Handshake, keywords: ["cercan", "proxim", "confian"] },
  { variant: "violet", Icon: Lightbulb, keywords: ["innov", "creativ", "ideas"] },
  { variant: "sky", Icon: Star, keywords: ["excel", "calidad", "mejor"] },
  { variant: "sunset", Icon: Eye, keywords: ["transpar", "honest", "clar"] },
  { variant: "fuchsia", Icon: Users, keywords: ["divers", "inclus", "equidad"] },
];

const FALLBACK_VARIANTS: CircleActionVariant[] = [
  "emerald",
  "violet",
  "sky",
  "sunset",
  "fuchsia",
];
const FALLBACK_ICONS: LucideIcon[] = [Handshake, Lightbulb, Star, Eye, Sparkles];

function normalizeTitle(title: string) {
  return title
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function resolveCorporateValueVisual(title: string, index = 0) {
  const normalized = normalizeTitle(title);

  for (const preset of PRESETS) {
    if (preset.keywords.some((keyword) => normalized.includes(keyword))) {
      return { variant: preset.variant, Icon: preset.Icon };
    }
  }

  const i = index % FALLBACK_VARIANTS.length;
  return { variant: FALLBACK_VARIANTS[i], Icon: FALLBACK_ICONS[i] };
}

/** Mapea la variante del tile/badge a la variante de Input/Textarea v2. */
export function circleVariantToFieldVariant(
  variant: CircleActionVariant
): FieldVariant {
  const map: Partial<Record<CircleActionVariant, FieldVariant>> = {
    indigo: "violet",
    violet: "violet",
    fuchsia: "rose",
    rose: "rose",
    sky: "sky",
    ocean: "sky",
    cyan: "sky",
    emerald: "emerald",
    mint: "emerald",
    lime: "emerald",
    gold: "amber",
    sunset: "amber",
    coral: "amber",
    slate: "slate",
  };

  return map[variant] ?? "slate";
}

export function resolveFieldVariantForCorporateValue(
  title: string,
  index = 0
): FieldVariant {
  const { variant } = resolveCorporateValueVisual(title, index);
  return circleVariantToFieldVariant(variant);
}
